import { render } from "./delete-sessions-warning.vue?vue&type=template&id=52246e32&lang=pug"
import script from "./delete-sessions-warning.vue?vue&type=script&setup=true&lang=js"
export * from "./delete-sessions-warning.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__